import { FormikErrors } from "formik";
import { useEffect } from "react";

import { VALIDATION_CLASS } from "utils/constants";

export default function useValidation(
  ref: React.RefObject<HTMLFormElement | HTMLDivElement | null>,
  errors: FormikErrors<unknown> | string,
) {
  useEffect(() => {
    const isStringError = !!errors && typeof errors === "string";
    const isObjectError = !!errors && typeof errors === "object" && Object.keys(errors)?.length;

    if (isStringError || isObjectError) {
      const validationFields = ref?.current?.querySelectorAll(`.${VALIDATION_CLASS}`);

      validationFields?.[0]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [errors, ref]);
}
